"use client";
import BuyNowCart from "@/components/common/BuyNowCart";
import MainLayout from "@/components/layout/mainLayout";
import ScoMeta from "@/components/scometa";
import AwardsBanner from "@/components/singlecask/AwardsBanner";
import SingleCaskAwardsSection from "@/components/singlecask/SingleCaskAwardsSection";
import { getCheckoutLineItems } from "@/util/utils";
import { useAppCommonStore } from "@/zustand/appCommon";
import { useEffect, useState } from "react";

const OurAwards = (props: any) => {
  const { data, meta } = props;
  const [ourAwardData, setOurAwardData]: any = useState(null);
  const {
    checkout,
    setCheckout,
    selectedCountry,
    updateQuantityInCart,
    removeLineItemInCart,
    openModal,
    toggleCartSidebar,
  } = useAppCommonStore((state: any) => ({
    checkout: state.checkout,
    setCheckout: state.setCheckout,
    selectedCountry: state.selectedCountry,
    updateQuantityInCart: state.updateQuantityInCart,
    removeLineItemInCart: state.removeLineItemInCart,
    openModal: state.openModal,
    toggleCartSidebar: state.toggleCartSidebar,
  }));

  useEffect(() => {
    getCheckoutLineItems(selectedCountry.value).then((res) => {
      setCheckout({
        ...res,
      });
    });
  }, []);

  useEffect(() => {
    if (data) {
      setOurAwardData(data?.data?.attributes?.blocks);
    }
  }, [data]);
  const renderOurAwardPage = () => {
    return (
      <>
        {ourAwardData && ourAwardData.length > 0
          ? ourAwardData.map((content: any, index: any) => {
              switch (content.__component) {
                case "awards.banner":
                  return (
                    <div key={index}>
                      <AwardsBanner data={content} />
                    </div>
                  );

                case "awards.award-table":
                  return (
                    <SingleCaskAwardsSection
                      key={content?.id + index}
                      data={content}
                    />
                  );

                default:
                  return null;
              }
            })
          : null}
      </>
    );
  };
  return (
    <>
      <BuyNowCart
        countryCode={selectedCountry.value}
        openModal={openModal}
        toggleCartSidebar={toggleCartSidebar}
        checkout={checkout}
        updateQuantityInCart={updateQuantityInCart}
        removeLineItemInCart={removeLineItemInCart}
      />
      <head>
        <ScoMeta meta={meta ? meta : {}} />
      </head>
      <MainLayout
        checkout={checkout}
        toggleCartSidebar={toggleCartSidebar}
      >
        <div>{ourAwardData && renderOurAwardPage()}</div>
      </MainLayout>
    </>
  );
};

export default OurAwards;
